<div style="padding: 20px;">
    <div class="table-card">
        <div class="table-header">
            <h2 class="table-title">{{ formatText(subMenu) }}</h2>
            <mat-form-field appearance="outline" class="custom-seash-input">
                <mat-label>Search</mat-label>
                <input matInput (keyup)="applyFilter($event)" [placeholder]="formatText(subMenu)" />
            </mat-form-field>
            <button mat-flat-button color="primary" class="reset-btn" 
                [disabled]="count == 0"
                [matMenuTriggerFor]="exportMenu">
                <mat-icon class="export-icon">download</mat-icon>
                Export
            </button>
            <mat-menu #exportMenu="matMenu" class="export-menu">
                <button mat-menu-item (click)="ExportTOExcel()" class="export-option">
                    <mat-icon class="option-icon">table_chart</mat-icon>
                    <span>Export as Excel (.xlsx)</span>
                </button>
                <button mat-menu-item (click)="exportToCSV()" class="export-option">
                    <mat-icon class="option-icon">description</mat-icon>
                    <span>Export as CSV (.csv)</span>
                </button>
                <button mat-menu-item (click)="exportToTxt()" class="export-option">
                    <mat-icon class="option-icon">text_snippet</mat-icon>
                    <span>Export as Text (.txt)</span>
                </button>
            </mat-menu>
        </div>
        <mat-divider style="margin-bottom: 10px;"></mat-divider>
        <table mat-table matSort [dataSource]="dataSource" class="workorder-table">
            <ng-container matColumnDef="DistributorCode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Distributor Code</th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.DistributorCode }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="DistributorName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Distributor Name</th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.DistributorName }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="UsersEmail">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.UsersEmail }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="ContactFirstName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact Name</th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.ContactFirstName }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="ContactPhoneNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.ContactPhoneNumber }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Address">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.Address }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="AccountNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Number</th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.AccountNumber }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="ActiveInactive">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Active/Inactive</th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.ActiveInactive }}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <ng-container *ngIf="count == 0 || dataSource?.data.length === 0">
            <div class="no-records">No records found.</div>
        </ng-container>
        <mat-paginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>
    </div>
</div>